export default __webpack_public_path__ + "static/media/six_of_cups.eded70a1.png";